import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
//import globalcontext
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetBatchsByStudentId } from '../../service/BatchService';
import { GetBatchesByStudentId } from '../../service/BatchStudentService';

export default function BatchList() {

  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  const [batchs, setBatchs] = useState();
  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;

  const id = appUser._id; // Get the student ID from the appUser context

  const fetchBatchList = async (page = 1) => {
    try {
      setIsLoading(true);
      var response = await GetBatchesByStudentId(id, page, itemsPerPage);
      setBatchs(response.mappedBatches);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTotalItems(response.totalItems);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchBatchList(currentPage);
  }, []);

  return (
    <>
      <Helmet>
        <title>Batch List | {config.appName} </title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Mapped Batch List</h1>
            <span>
              <Link to="/"> Dashboard </Link> / Mapped Batch List
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label htmlFor="gender" className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input type="text" className="form-control" value={keyword} onChange={(e) => setKeyword(e.target.value)} />
                          <button className="btn btn-outline-secondary" type="button" id="button-addon1">
                            <FontAwesomeIcon icon="fa-solid fa-search" onClick={() => fetchBatchList(1)} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Image</th>                        
                        <th>Trainer</th>
                        <th>Name</th>
                        <th>Code</th>
                        <th>Start Date</th>
                        <th>Fee (Rs.)</th>
                        <th>Certificate</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* iterate the batchs and display in table */}
                      {batchs && batchs.map((batch) => (
                        <tr key={batch._id}>
                          <td>
                            {/* <img src={config.apiUrl + "uploads/batchs/" + batch._id + "." + batch.image} alt={batch.name} className='img-fluid image-xs' /> */}
                            <img
                              src={`${config.imageBasePath}/batches/${batch.batchId._id}.${batch.batchId.image}`}
                              alt={batch.batchId.name} className='img-fluid image-xs'
                            />
                          </td>                          
                          <td>{batch.batchId.trainerId?.username}</td>
                          <td>{batch.batchId.name}</td>
                          <td>{batch.batchId.code}</td>
                          <td>
                            {batch.batchId.startDate
                              ? (() => {
                                const date = new Date(batch.batchId.startDate);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                return `${day}-${month}-${year}`;
                              })()
                              : ''}
                          </td>
                          <td>{batch.batchId.fee}</td>
                          <td>{batch.batchId.certificate ? 'Yes' : 'No'}</td>
                          <td>
                            <Link to={`/batch-lesson-planner/manage/${batch.batchId._id}`} className='btn btn-sm btn-success' style={{ marginTop: '5px' }}>
                              <FontAwesomeIcon icon="fa-solid fa-book" /> Lesson Planner
                            </Link>&nbsp;
                            {batch.batchId?.fee > 0 && (
                              <>
                                <Link to={`/batch/summary/manage/${batch.batchId._id}`} className='btn btn-sm btn-primary d-none' style={{ marginTop: '5px' }}>
                                  <FontAwesomeIcon icon="fa-solid fa-coins" /> Fee Details
                                </Link>
                                 <Link to={`/batch-student/manage/${batch.batchId._id}`} className='btn btn-sm btn-danger' style={{ marginTop: '5px' }}>
                                  <FontAwesomeIcon icon="fa-solid fa-coins" /> Payment
                                </Link>
                                 <Link to={`/batch/forum/manage/list/${batch.batchId._id}`} className='btn btn-sm btn-primary' style={{ marginTop: '5px', marginLeft: '5px' }}>
                                <FontAwesomeIcon icon="fa-solid fa-comment-dots" /> Forum
                              </Link>  
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {totalItems > 10 && (
                    <div className="pagination mt-3 d-flex justify-content-center">
                      <span className="align-self-center me-3">
                        {currentPage > 1 && (
                          <button
                            className="btn btn-outline-primary me-2"
                            onClick={() => fetchBatchList(currentPage - 1)}
                          >
                            Previous
                          </button>
                        )}

                        Page {currentPage} of {totalPages}

                        {currentPage < totalPages && (
                          <button
                            className="btn btn-outline-primary ms-2"
                            onClick={() => fetchBatchList(currentPage + 1)}
                          >
                            Next
                          </button>
                        )}
                      </span>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
